// FindIdPage.tsx
import React, {useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {changePasswordSubmit, clearTokens} from '../../api/authApi';
import axios, {AxiosError} from 'axios';
import {defaultAlert} from "../../utils/alert";
import {handleLoginError} from "./LoginPage";
import {isNullOrEmpty} from "../../utils/validation";
import {validatePassword} from "../../utils/validation";

export default function LoginPasswordChangePage() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isPasswordMatching, setIsPasswordMatching] = useState<boolean>(false);
    const isAxiosError = (error: unknown): error is AxiosError => {
        return axios.isAxiosError(error);
    };

    const [form, setForm] = useState({
        nowPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const {name, value} = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }));

        setIsPasswordMatching(
            !isNullOrEmpty(form.nowPassword) && !isNullOrEmpty(form.newPassword) && !isNullOrEmpty(form.confirmPassword)
        );
    };

    const handleSubmit = async () => {
        if (!validatePassword(form.newPassword)) {
            defaultAlert('비밀번호는 영문 대소문자/숫자/특수문자 중 2가지 이상 조합, 8~20자여야 합니다.');
            return;
        }

        if (form.newPassword !== form.confirmPassword) {
            defaultAlert('새로운 비밀번호가 일치하지 않습니다.');
            return;
        }

        try {
            const res = await changePasswordSubmit({
                memberId: location.state.memberId,
                nowPassword: form.nowPassword,
                newPassword: form.newPassword
            });

            const tokenCode = res.data.code;

            if(tokenCode == "00") {
                defaultAlert('비밀번호가 변경되었습니다. 다시 로그인해주세요.');
                clearTokens();
                navigate("/login");
            } else {
                defaultAlert(res.data?.message || '수정에 실패했습니다.');
            }
        } catch (error) {
            if (isAxiosError(error)) {
                handleLoginError(error);
            } else {
                defaultAlert('예기치 않은 오류가 발생했습니다.');
                console.error('Unknown error:', error);
            }
        }
    };

    return (
        <div className="app">
            <header className="sub-header">
                <div className="header-inner">
                    <button type="button" className="backBtn" onClick={() => navigate(-1)}><span className="blind">뒤로가기</span></button>
                </div>
            </header>
            <div className="bottom-btn">
                <button id="submitBtn" type="button" className="btn confirm" disabled={!isPasswordMatching} onClick={handleSubmit}>비밀번호 변경</button>
            </div>
            <main className="container">
                <section className="tit-box-wrap">
                    <h2 className="headline">새 비밀번호 설정</h2>
                    <p className="subtit">정보보호를 위해 새 비밀번호를 입력해 주세요</p>
                </section>
                <section>
                    <div className="inner-box">
                        <form method="post" id="">
                            <fieldset>
                                <legend>비밀번호 변경 폼</legend>
                                <div className="form-box">
                                    <div className="form-item">
                                        <label htmlFor="" className="input-tit">현재 비밀번호</label>
                                        <div className="input-box">
                                            <input type="password" id="nowPassword" name="nowPassword" placeholder="현재 비밀번호를 입력해 주세요." onChange={handleChange}/>
                                        </div>
                                    </div>
                                    <div className="form-item">
                                        <label htmlFor="" className="input-tit">새로운 비밀번호를 입력하세요</label>
                                        <div className="input-box">
                                            <input type="password" id="newPassword" name="newPassword" placeholder="비밀번호 설정(영문 대소문자/숫자/특수문자 중 2가지 이상 8자~20자)" onChange={handleChange}/>
                                        </div>
                                    </div>
                                    <div className="form-item">
                                        <label htmlFor="" className="input-tit">새 비밀번호를 재입력하세요</label>
                                        <div className="input-box">
                                            <input type="password" id="confirmPassword" name="confirmPassword" placeholder="비밀번호 재확인" onChange={handleChange}/>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
}